<template>
  <div v-if="dataIsLoad" id="info-sidebar" class="product-info">
    <div class="product-attribute">
      <span v-if="!selectedFoodSpec.Product.IsOutOfStock" class="product-preorder">
        [ {{ isPreOrder }} ]
      </span>
      <span class="product-temp">[{{ productTemperature }}]</span>
    </div>
    <h1 class="product-name" :class="{ noEvent }">
      {{ selectedFoodSpec.Product.Name }}
    </h1>
    <h5 class="product-sub-name">{{ selectedFoodSpec.Product.SubTitle }}</h5>
    <div v-if="!noEvent" class="product-event">
      <div v-if="selectedFoodSpec.Product.LimitAmount !== 0">
        此商品限購 {{ selectedFoodSpec.Product.LimitAmount }} 件
      </div>
      <div v-for="event in selectedFoodSpec.Product.Events" :key="event.ID">
        <a :href="'/campaign/' + event.ID">{{ event.Name }}</a>
      </div>
      <div v-for="giftEvent in selectedFoodSpec.Product.GiftEvents" :key="giftEvent.ID">
        <a :href="'/campaign/gift/' + giftEvent.ID">{{ giftEvent.Name }}</a>
      </div>
    </div>
    <h3 class="product-price">
      <span
        v-if="mapOriginPrice"
        class="origin-price"
        :class="{
          mark: mapOriginPrice,
        }"
      >
        NT.{{ selectedFoodSpec.Product.OriginPrice.toLocaleString() }}
      </span>
      <span
        class="sell-price"
        :class="{
          mark: mapOriginPrice,
        }"
      >
        NT.{{ mapSellPrice }}
      </span>
    </h3>
    <h5 v-if="selectedFoodSpec.Product.PreOrder" class="product-sub-name">
      {{ selectedFoodSpec.Product.ArrivalExplanation }}
    </h5>
    <div class="d-none d-md-block product-color-wrap">
      <div class="selected-color">
        {{ userSelectFlavor.Title !== null ? userSelectFlavor.Title : '口味' }}
      </div>
      <div
        v-for="(flavors, index) in itemDatas.Flavors"
        :key="flavors.Name"
        :class="{
          active: flavors.Name === userSelectFlavor.Name,
          soldOut: flavors.Stock === 0,
          noColorIcon: !itemDatas.ShowColorIcon,
          showColorIcon: itemDatas.ShowColorIcon,
        }"
        @click.prevent="changeFlavor(index)"
      >
        <div v-if="!itemDatas.ShowColorIcon" class="taste-cross-line" />
        <span v-if="!itemDatas.ShowColorIcon">{{ flavors.Name }}</span>
        <img v-else :src="flavors.Specs[0].Product.PintSizePictureUrl + '?w=20&h=20'" />
      </div>
    </div>
    <p v-if="selectedFoodSpec.Stock < 10 && selectedFoodSpec.Stock !== 0" class="text-danger my-2">
      即將售完
    </p>
    <div class="d-none d-md-flex product-select-container">
      <div class="size-selector">
        <p class="mb-1">{{ selectedFoodSpec.Title !== null ? selectedFoodSpec.Title : '規格' }}</p>
        <FoodSelect
          :options="userSelectFlavor.Specs"
          :selected="selectedFoodSpec"
          @changeFoodSpec="selectFoodSpec"
        />
      </div>
      <div class="count-selector">
        <p class="mb-1">數量</p>
        <div class="quantity">
          <a class="quantity-btn-minus" @click.prevent="reduceCount">–</a>
          <input :value="counter" class="quantity-text" type="text" readonly />
          <a
            class="quantity-btn-plus"
            @click.prevent="
              addCount({
                maxCount: selectedFoodSpec.Stock,
                limit: selectedFoodSpec.Product.LimitAmount,
              })
            "
          >
            ＋
          </a>
        </div>
      </div>
    </div>
    <a
      :class="foodBtnStyle"
      class="btn d-none d-md-block mt-3 btn-add-cart"
      @click.prevent="clickToCart(foodAddToCart)"
    >
      {{ foodBtnDescription }}
    </a>

    <div id="bottom-bar" class="d-lg-none">
      <a
        :class="btnStyle"
        class="open-dialog btn-add-cart btn"
        data-dialog="#dialog-market-series"
        @click.prevent="showMobileCartDialog"
      >
        {{ description }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import $ from 'jquery';

import useShopContentStore from '@global/stores/useShopContentStore';
import useSpec from '@global/composable/useSpec';

import FoodSelect from '@components/FoodSelect.vue';

const shopContentStore = useShopContentStore();
const {
  itemDatas,
  selectedFoodSpec,
  userSelectFlavor,
  dataIsLoad,
  counter,
  foodBtnStyle,
  foodBtnDescription,
} = storeToRefs(shopContentStore);
const { changeFlavor, selectFoodSpec, addCount, reduceCount, showMobileCartDialog, foodAddToCart } =
  shopContentStore;

const {
  mapOriginPrice,
  IsPreOrderFactory,
  IsMapSellPriceFactory,
  IsProductTemperatureFactory,
  IsNoEventFactory,
  IsBtnStyleFactory,
  IsDescriptionFactory,

  clickToCart,
} = useSpec();

const isPreOrder = computed(() => IsPreOrderFactory(selectedFoodSpec.value?.Product));
const mapSellPrice = computed(() => IsMapSellPriceFactory(selectedFoodSpec.value?.Product));
const productTemperature = computed(() =>
  IsProductTemperatureFactory(selectedFoodSpec.value?.Product),
);
const noEvent = computed(() => IsNoEventFactory(selectedFoodSpec.value?.Product));
const btnStyle = computed(() => IsBtnStyleFactory(selectedFoodSpec.value?.Product));
const description = computed(() => IsDescriptionFactory(selectedFoodSpec.value?.Product));
</script>
